import React, { useEffect, useState } from "react";
import Swiper from "swiper/bundle";
import "swiper/css/bundle";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronLeft, ChevronRight, Quote, Star } from "lucide-react";
import Lottie from "lottie-react";
import affordableAnimation from "../lottie/health-insurance.json";
import familyAnimation from "../lottie/Family-Insurance.json";
import claimsAnimation from "../lottie/Approved.json";
import supportAnimation from "../lottie/suportee.json";
import Header from "../components/Header";

const HomePage = () => {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const swiper = new Swiper(".h3-partner_slider", {
      slidesPerView: 2,
      spaceBetween: 15,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      breakpoints: {
        768: { slidesPerView: 3, spaceBetween: 30 },
        992: { slidesPerView: 5, spaceBetween: 30 },
      },
    });

    return () => swiper.destroy(true, true); // cleanup
  }, []);
  useEffect(() => {
    const swiper = new Swiper(".h3-testimonial-slider", {
      slidesPerView: 1,
      spaceBetween: 15,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      breakpoints: {
        768: { slidesPerView: 1, spaceBetween: 30 },
        992: { slidesPerView: 1, spaceBetween: 30 },
      },
    });

    return () => swiper.destroy(true, true); // cleanup
  }, []);

  const features = [
  {
    title: "Affordable Healthcare Plans",
    desc: "Flexible OPD subscriptions that deliver quality consultations, diagnostics and wellness services at a predictable cost.",
    animation: affordableAnimation,
  },
  {
    title: "Coverage For Every Family",
    desc: "Choose plans tailored for individuals, parents, children and entire families with scalable benefits.",
    animation: familyAnimation,
  },
  {
    title: "Fast & Simple Claims",
    desc: "Digital claim processing with minimal paperwork and quick turnaround times for a seamless experience.",
    animation: claimsAnimation,
  },
  {
    title: "Dedicated Support Team",
    desc: "Our healthcare specialists are available to assist you with claims, appointments and plan guidance.",
    animation: supportAnimation,
  },
];

  const testimonials = [
    {
      id: 1,
      name: "Ashish Mehta",
      location: "Bangalore",
      initials: "AM",
      title: "Effortless Healthcare",
      review:
        "The customer support is exceptional, and the platform is incredibly easy to use. I feel confident knowing my healthcare needs are always covered.",
    },
    {
      id: 2,
      name: "Rahul Gupta",
      location: "Chandigarh",
      initials: "RG",
      title: "Doctor in Minutes",
      review:
        "Booking consultations has never been easier. The process is smooth, fast, and saves me valuable time every single month.",
    },
    {
      id: 3,
      name: "Neha Gujral",
      location: "Jaipur",
      initials: "NG",
      title: "Excellent Coverage",
      review:
        "Their OPD coverage has helped me reduce healthcare expenses significantly while still receiving quality care.",
    },
    {
      id: 4,
      name: "Pooja Verma",
      location: "Delhi",
      initials: "PV",
      title: "Seamless Experience",
      review:
        "Everything from consultations to diagnostics feels effortless. It's exactly what modern healthcare should look like.",
    },
  ];

  const services = [
    {
      title: "Diagnostics",
      description:
        "Accurate pathology and laboratory testing with trusted healthcare partners.",
      image: "assets/images/portfolio-1.jpg",
    },
    {
      title: "Medical Scans",
      description:
        "Advanced MRI, CT Scan, X-Ray and imaging services near you.",
      image: "assets/images/portfolio-2.jpg",
    },
    {
      title: "Pharmacy",
      description:
        "Order genuine medicines online with quick doorstep delivery.",
      image: "assets/images/portfolio-3.jpg",
    },
    {
      title: "Tele Consultation",
      description:
        "Consult experienced doctors anytime through secure video calls.",
      image: "assets/images/portfolio-4.jpg",
    },
    {
      title: "Doctor Consultation",
      description:
        "Book appointments with certified specialists in just a few clicks.",
      image: "assets/images/portfolio-5.jpg",
    },
  ];

  const featuresok = [
  {
    id: "01",
    title: "Hassle-Free Benefits",
    description:
      "Instant access to doctors, diagnostics, treatments and wellness services with zero paperwork.",
    image: "/assets/images/hassel-free.svg",
  },
  {
    id: "02",
    title: "Save on Daily Care",
    description:
      "Reduce consultation, pharmacy and diagnostic costs with affordable OPD plans.",
    image: "/assets/images/daily-care.svg",
  },
  {
    id: "03",
    title: "India's Wellness Network",
    description:
      "Access hospitals, clinics and labs across India through our trusted healthcare network.",
    image: "/assets/images/india-circle.svg",
  },
  {
    id: "04",
    title: "Quick & Easy Start",
    description:
      "Join in minutes with a simple online process and start using your healthcare benefits immediately.",
    image: "/assets/images/fast-and-simple-claim.svg",
  },
];

  useEffect(() => {
    const interval = setInterval(() => {
      setActive((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const nextSlide = () => {
    setActive((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setActive((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  useEffect(() => {
    const swiper = new Swiper(".services-slider", {
      slidesPerView: 4,
      spaceBetween: 0,
      loop: true,
      speed: 1000,
      freeMode: true,
      autoplay: {
        delay: 2000,
      },
      navigation: {
        nextEl: ".services-swiper-button-next",
        prevEl: ".services-swiper-button-prev",
      },
      breakpoints: {
        10: {
          slidesPerView: 1,
        },
        575: {
          slidesPerView: 1,
        },

        768: {
          slidesPerView: 2,
        },

        992: {
          slidesPerView: 3,
        },
        1200: {
          slidesPerView: 4,
        },
      },
    });

    return () => swiper.destroy(true, true);
  }, []);

  useEffect(() => {
    const swiper = new Swiper(".h3-partner_slider", {
      slidesPerView: 2,
      spaceBetween: 15,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      breakpoints: {
        768: { slidesPerView: 3, spaceBetween: 30 },
        992: { slidesPerView: 6, spaceBetween: 30 },
      },
    });

    return () => swiper.destroy(true, true);
  }, []);

  return (
    <>
    <Header/>
    <main>
      <section 
        className="relative overflow-hidden bg-white"
        // data-aos="fade"
      >
        {/* Background Effects */}
        {/* <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute -top-32 -left-32 w-[500px] h-[500px] rounded-full bg-[#D4CB2F]/10 blur-3xl" />
          <div className="absolute top-40 right-0 w-[450px] h-[450px] rounded-full bg-[#55534F]/10 blur-3xl" />

          <div className="absolute top-20 right-20 w-6 h-6 rounded-full bg-[#D4CB2F]/50 animate-bounce" />
          <div className="absolute bottom-20 left-20 w-4 h-4 rounded-full bg-[#55534F]/50 animate-pulse" />
        </div> */}

        <div className="theme-container relative  mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center py-12 lg:py-20">
            {/* LEFT CONTENT */}
            <div className="">
              {/* Trust Badge */}
              <div className="inline-flex items-center gap-3 rounded-full border border-[#D4CB2F]/30 bg-[#D4CB2F]/10 px-3 py-2 md:px-4 md:py-2.5 mb-6">
                <span className="flex h-2 w-2 md:h-3 md:w-3 rounded-full bg-[#D4CB2F]/80" />
                <span className="text-[10px] md:text-[14px] font-semibold text-[#55534F]">
                  Trusted Healthcare • OPD Plans • Wellness Support
                </span>
              </div>

              {/* Heading */}
              <h1 className="text-[38px] sm:text-[42px] md:text-[52px] lg:text-[68px] leading-[1.1] font-bold text-[#55534F]">
                Healthcare
                <span className="block text-[#D4CB2F]">Simplified</span>
                For Every Family
              </h1>

              {/* Description */}
              <p className="mt-6 text-sm md:text-[18px] text-[#666] max-w-xl leading-relaxed">
                Get instant access to doctor consultations, diagnostics,
                preventive care, and wellness benefits through affordable OPD
                plans designed for modern healthcare needs.
              </p>

              {/* Feature Pills */}
              <div className="flex flex-wrap gap-3 mt-6 text-[12px] md:text-[14px]">
                <div className="px-1.5 py-1 md:px-3 md:py-1.5 rounded-full bg-[#F7F7F7] text-[#55534F] font-medium">
                  ✓ Doctor Consultations
                </div>
                <div className="px-1.5 py-1 md:px-3 md:py-1.5 rounded-full bg-[#F7F7F7] text-[#55534F] font-medium">
                  ✓ Diagnostic Benefits
                </div>
                <div className="px-1.5 py-1 md:px-3 md:py-1.5 rounded-full bg-[#F7F7F7] text-[#55534F] font-medium">
                  ✓ Cashless Experience
                </div>
              </div>

              {/* CTA */}
              <div className="flex flex-col sm:flex-row gap-4 mt-6 md:mt-8">
                <a href="/plans">
                  <div
                    className="group inline-flex items-center gap-3 rounded-full px-6 py-3 text-[14px] md:text-[16px] md:px-8 md:py-4 font-semibold text-white transition-all duration-300 hover:-translate-y-1"
                    style={{
                      background:
                        "linear-gradient(90deg,#D4CB2F 0%,#55534F 100%)",
                      boxShadow: "0 10px 35px rgba(212,203,47,0.25)",
                    }}
                  >
                    Explore Plans
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M5 12H19M19 12L13 6M19 12L13 18"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </a>
              </div>

              {/* Stats */}
              <div className="grid grid-cols-3 gap-4 md:gap-6 mt-6 md:mt-10 pt-6 md:pt-8 border-t border-gray-200">
                <div>
                  <h3 className="text-xl md:text-3xl font-bold text-[#D4CB2F]">
                    10K+
                  </h3>
                  <p className="text-[10px] md:text-sm text-[#666]">
                    Members Covered
                  </p>
                </div>

                <div>
                  <h3 className="text-xl md:text-3xl font-bold text-[#D4CB2F]">
                    24/7
                  </h3>
                  <p className="text-[10px] md:text-sm text-[#666]">
                    Healthcare Access
                  </p>
                </div>

                <div>
                  <h3 className="text-xl md:text-3xl font-bold text-[#D4CB2F]">
                    100+
                  </h3>
                  <p className="text-[10px] md:text-sm text-[#666]">
                    Healthcare Partners
                  </p>
                </div>
              </div>
            </div>

            {/* RIGHT IMAGE */}
            <div className="relative">
              {/* Glow */}
              <div
                className="absolute inset-0 rounded-full blur-3xl"
                style={{
                  background:
                    "radial-gradient(circle, rgba(212,203,47,.25) 0%, transparent 70%)",
                }}
              />

              {/* Main Circle */}
              <div
                className="relative mx-auto overflow-hidden p-1.5 md:p-2 rounded-[40px] max-w-[650px]"
                style={{
                  background: "linear-gradient(135deg,#D4CB2F 0%,#55534F 100%)",
                }}
              >
                <div className="overflow-hidden rounded-[32px] bg-white h-[420px] md:h-[550px] lg:h-[500px]">
                  <img
                    src="/assets/images/hero.jpg"
                    alt="S Meera Health hero"
                    className="w-full h-full object-cover hover:scale-105 transition-all duration-700"
                  />
                </div>
              </div>

              {/* Floating Card 1 */}
              <div className="hidden md:flex absolute bottom-10 -left-10 bg-white/90 border-[#D4CB2F] border-2 shadow-xl rounded-2xl px-5 py-4 items-center gap-3">
                <div className="w-12 h-12 rounded-full  flex items-center justify-center">
                  <img
                    src="/assets/images/doctor-checkup.svg"
                    alt="doctor"
                    className="w-full h-full object-cover hover:scale-105 transition-all duration-700"
                  />
                </div>
                <div>
                  <h4 className="font-semibold text-[#55534F]">
                    Doctor Access
                  </h4>
                  <p className="text-sm text-gray-500">Instant Consultation</p>
                </div>
              </div>

              {/* Floating Card 2 */}
              <div className="hidden md:flex absolute top-10 -right-10 bg-white/90 shadow-xl border-[#D4CB2F] border-2 rounded-2xl px-5 py-4 items-center gap-3">
                <div className="w-12 h-12 rounded-full flex items-center justify-center">
                  <img
                    src="/assets/images/checking.svg"
                    alt="checking"
                    className="w-full h-full object-cover hover:scale-105 transition-all duration-700"
                  />
                </div>
                <div>
                  <h4 className="font-semibold text-[#55534F]">
                    Wellness Plans
                  </h4>
                  <p className="text-sm text-gray-500">Affordable Coverage</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="relative overflow-hidden bg-[#1B1A18] py-16 lg:py-28">
        {/* Background Glow */}

        <div className="absolute left-0 top-0 h-80 w-80 rounded-full bg-[#D4CB2F]/10 blur-[120px]" />

        <div className="absolute right-0 bottom-0 h-96 w-96 rounded-full bg-[#D4CB2F]/10 blur-[140px]" />

        <div className="relative container mx-auto px-5">
          {/* Header */}

          <div className="max-w-3xl mx-auto text-center mb-16">
            <span
              className="
                inline-flex
                items-center
                rounded-full
                border
                border-[#D4CB2F40]
                bg-[#D4CB2F]/10
                px-4
                py-1.5
                md:px-6
                md:py-2
                text-[12px]
                md:text-sm
                font-semibold
                uppercase
                tracking-[3px]
                text-[#D4CB2F]"
            >
              Medical Services
            </span>

            <h2
              className="
              mt-4
                md:mt-6
                text-3xl
                md:text-4xl
                lg:text-5xl
                font-extrabold
                leading-tight
                text-white"
            >
              Healthcare Services
              <br />
              <span className="text-[#D4CB2F]">Designed Around You</span>
            </h2>

            <p className="md:4 md:mt-6 text-[14px] md:text-[18px] leading-5 md:leading-8 text-gray-400">
              Access trusted healthcare solutions including diagnostics,
              consultations, pharmacy services, and more—all in one seamless
              experience.
            </p>
          </div>

          {/* Cards */}

          <div className="swiper services-slider">
            <div className="swiper-wrapper">
              {services.map((service, index) => (
                <div className="swiper-slide p-2 md:p-3" key={index}>
                  <div
                    className="
                            group
                            relative
                            overflow-hidden
                            rounded-[24px]
                            md:rounded-[30px]
                            border
                            border-[#D4CB2F]/20
                            bg-[#252320]
                            transition-all
                            duration-500
                            hover:-translate-y-3
                            hover:border-[#D4CB2F]/60
                            hover:shadow-[0_0_45px_rgba(212,203,47,.18)]
                            "
                  >
                    {/* Image */}

                    <div className="relative h-[380px] md:h-[420px] overflow-hidden">
                      <img
                        src={service.image}
                        alt={service.title}
                        className="
                                    h-full
                                    w-full
                                    object-cover
                                    duration-700
                                    group-hover:scale-110
                                    "
                      />

                      <div className="absolute inset-0 bg-gradient-to-t from-[#1B1A18] via-[#1B1A18]/40 to-transparent" />
                    </div>

                    {/* Content */}

                    <div className="absolute bottom-0 left-0 right-0 p-7">
                      <div
                        className="
                                    mb-5
                                    h-[3px]
                                    w-14
                                    rounded-full
                                    bg-[#D4CB2F]
                                    transition-all
                                    duration-500
                                    group-hover:w-24
                                    "
                      />

                      <h3 className="text-xl md:text-2xl font-bold text-white">
                        {service.title}
                      </h3>

                      <p className="mt-3 md:mt-4 text-[15px] md:text-[18px] text-gray-300 leading-7">
                        {service.description}
                      </p>

                      {/* <button
                        className="
                                    mt-6
                                    inline-flex
                                    items-center
                                    gap-3
                                    font-semibold
                                    text-[#D4CB2F]
                                    transition-all
                                    duration-300
                                    group-hover:gap-5
                                    "
                      >
                        Learn More
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 20 20"
                          fill="none"
                        >
                          <path
                            d="M4 10H16"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                          />

                          <path
                            d="M10 4L16 10L10 16"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                          />
                        </svg>
                      </button> */}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      

      <section className="relative py-16 md:py-32 overflow-hidden bg-white ">
        {/* bg-[#faf9f4] */}
        {/* Background Glow */}
        <div className="absolute top-0 left-0 w-[600px] h-[600px] rounded-full bg-[#D4CB2F]/10 blur-[140px]" />
        <div className="absolute bottom-0 right-0 w-[500px] h-[500px] rounded-full bg-[#55534F]/10 blur-[120px]" />

        {/* Ripple */}
        <div className="absolute -top-1 -left-1 flex justify-center items-center w-2 h-2">
          <div className="animated_circle border border-[#D4CB2F]/20" />
          <div className="animated_circle2 border border-[#D4CB2F]/20" />
          <div className="animated_circle3 border border-[#D4CB2F]/20" />
          <div className="animated_circle4 border border-[#D4CB2F]/20" />
        </div>

        {/* Floating SVG */}
        <div className="absolute top-20 right-20 hidden lg:block">
          <svg
            className="w-20 h-20 text-[#D4CB2F]/90 animate-pulse"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path d="M10 4h4v6h6v4h-6v6h-4v-6H4v-4h6z" />
          </svg>
        </div>

        <div className="theme-container mx-auto relative z-10  ">
          {/* Heading */}
          <div className="text-center max-w-4xl mx-auto">
            <span className="inline-flex items-center gap-3 rounded-full border border-[#D4CB2F]/30 bg-[#D4CB2F]/10 px-3 py-2 md:px-4 md:py-2.5 text-[12px] md:text-[14px]">
              Why Choose S-Meera
            </span>

            <h2
              className="  mt-4
                md:mt-6
                text-3xl
                md:text-4xl
                lg:text-5xl
                font-extrabold
                leading-tight
                text-black"
            >
              Comprehensive Healthcare
              <span className="block text-[#D4CB2F]">Designed Around You</span>
            </h2>

            <p className="mt-4 md:mt-6 text-sm md:text-lg text-[#55534F] max-w-3xl mx-auto">
              Access consultations, diagnostics and wellness benefits through
              affordable plans crafted for modern families.
            </p>
          </div>

          {/* Feature Cards */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 xl:gap-8 mt-14 md:mt-20">
            {features.map((item, index) => (
              <div
                key={index}
                className="group relative overflow-hidden rounded-[30px]
      border border-[#D4CB2F]/15
      bg-white/90 backdrop-blur-xl
      p-6 md:p-8 xl:p-10
      transition-all duration-500
      hover:-translate-y-3
      hover:border-[#D4CB2F]/50
      hover:shadow-[0_30px_70px_rgba(212,203,47,0.18)]"
              >
                {/* Animated Gradient Border */}
                <div className="absolute inset-0 rounded-[30px] opacity-0 group-hover:opacity-100 transition-all duration-700 pointer-events-none">
                  <div className="absolute inset-0 rounded-[30px] border border-[#D4CB2F]/30"></div>
                </div>

                {/* Glow */}
                <div className="absolute -top-20 -right-20 w-52 h-52 bg-[#D4CB2F]/10 blur-[90px] rounded-full opacity-0 group-hover:opacity-100 transition-all duration-700" />

                {/* Bottom Glow */}
                <div className="absolute -bottom-16 -left-16 w-44 h-44 bg-[#55534F]/10 blur-[90px] rounded-full opacity-0 group-hover:opacity-100 transition-all duration-700" />

                {/* Small Badge */}
                <div className="absolute top-6 right-6 opacity-0 group-hover:opacity-100 transition duration-500">
                  <div className="w-2 h-2 rounded-full bg-[#D4CB2F] animate-pulse"></div>
                </div>

                <div className="relative z-10 flex flex-col sm:flex-row items-start gap-5 md:gap-7">
                  {/* Icon */}
                  <div
                    className="
          relative shrink-0
          w-16 h-16
          md:w-20 md:h-20
          rounded-3xl
          flex items-center justify-center
          bg-gradient-to-br
          from-[#D4CB2F]/20
          to-[#55534F]/10
          border border-[#D4CB2F]/20
          transition-all duration-500
          group-hover:rotate-6
          group-hover:scale-110"
                  >
                    <div className="absolute inset-0 rounded-3xl bg-[#D4CB2F]/5 blur-xl"></div>

                    <Lottie
                      animationData={item.animation}
                      loop
                      autoplay
                      className="relative w-10 h-10 md:w-14 md:h-14"
                    />
                  </div>

                  {/* Content */}
                  <div className="flex-1">
                    <div className="flex items-center justify-between gap-4">
                      <h3 className="text-lg md:text-2xl font-bold text-[#1f1f1f] transition-colors duration-300 group-hover:text-black">
                        {item.title}
                      </h3>

                      <div
                        className="
              opacity-0
              translate-x-4
              group-hover:opacity-100
              group-hover:translate-x-0
              transition-all duration-500"
                      >
                        <svg
                          className="w-6 h-6 text-[#D4CB2F]"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M5 12h14M13 5l7 7-7 7"
                          />
                        </svg>
                      </div>
                    </div>

                    <p className="mt-4 text-[15px] md:text-[16px] leading-7 text-[#55534F]">
                      {item.desc}
                    </p>

                    {/* Bottom Line */}
                    <div className="mt-6 h-[2px] w-16 bg-[#D4CB2F]/30 transition-all duration-500 group-hover:w-28 group-hover:bg-[#D4CB2F]" />
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Clients */}
          
        </div>


        <div className="absolute bottom-20 left-20 hidden lg:block">
          <svg
            className="w-20 h-20 text-[#D4CB2F]/90 animate-pulse"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path d="M10 4h4v6h6v4h-6v6h-4v-6H4v-4h6z" />
          </svg>
        </div>
      </section>

        <section className="py-16 md:py-24 bg-[#faf9f4] ">
          <div className="theme-container mx-auto">
            <span className="inline-flex items-center gap-3 rounded-full border border-[#D4CB2F]/30 bg-[#D4CB2F]/10 px-3 py-2 md:px-4 md:py-2.5 text-[12px] md:text-[14px]">
              Trusted By Organizations
            </span>

            <h2
              className="mt-3 md:mt-6
                md:mt-6
                text-3xl
                md:text-4xl
                lg:text-5xl
                font-extrabold
                leading-tight
                text-black"
            >
              Trusted By Leading
              <span className="block text-[#D4CB2F]">Healthcare Partners</span>
            </h2>

            <div className="mt-10 md:mt-16">
              <div className="swiper h3-partner_slider overflow-hidden">
                <div className="swiper-wrapper">
                  {[1, 2, 4, 5, 6, 7, 8 , 9].map((item) => (
                    <div className="swiper-slide" key={item}>
                      <div className="h-[90px] md:h-[120px] rounded-3xl bg-white border border-[#D4CB2F]/10 flex items-center justify-center hover:shadow-[0_20px_40px_rgba(212,203,47,0.15)] transition-all duration-300">
                        <img
                          src={`assets/images/partner_logo/${item}.svg`}
                          alt=""
                          className="max-h-[60px] min-w-[140px] object-contain"
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            </div>
          </section>

      {/* <section className="pt-16">
        <div className="theme-container mx-auto flex flex-col items-center">
          <h1
            className="inline-flex items-center gap-3 rounded-full border border-[#D4CB2F]/30 bg-[#D4CB2F]/10 px-3 py-2 md:px-4 md:py-2.5 text-[12px] md:text-[14px]"
          >
            What We Provide
          </h1>
          <h2
            className="text-main-black pt-5 max-w-[692px] text-center mt-4
                text-3xl
                md:text-4xl
                lg:text-5xl
                font-extrabold
                leading-tight"
          >
            Pathways to Progress: <p className="block text-[#D4CB2F]">Our Mission, Vision, and Goals</p>
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-5 md:gap-8 py-12 md:py-20 w-[80%] mx-auto">
          {featuresok.map((feature) => (
            <div
              key={feature.id}
              className="group relative overflow-hidden rounded-[30px] border border-[#D4CB2F]/20 bg-[#F8F8F5] p-6 md:p-8 transition-all duration-500 hover:-translate-y-3 hover:shadow-[0_25px_60px_rgba(212,203,47,.18)]"
            >
              <div className="absolute inset-x-0 bottom-0 h-0 bg-gradient-to-br from-[#D4CB2F] via-[#C4BC2B] to-[#55534F] transition-all duration-700 group-hover:h-full z-0" />

              <span className="absolute right-6 top-4 text-[60px] md:text-[90px] font-black text-[#4a4702c7] z-10">
                {feature.id}
              </span>

              <div className="relative z-20">
                <div className="flex md:h-16 md:w-16 h-14 w-14 items-center justify-center rounded-2xl bg-[#D4CB2F]/10 border border-[#D4CB2F]/20 transition-all duration-500 group-hover:bg-white group-hover:scale-110">
                  <img
                    src={feature.image}
                    alt={feature.title}
                    className="h-8 w-8 md:h-10 md:w-10 object-contain transition-all duration-500"
                  />
                </div>

                <h3 className="mt-5 md:mt-8 text-lg md:text-2xl font-bold text-[#3F3D3A] transition-all duration-500 group-hover:text-white">
                  {feature.title}
                </h3>

                <p className="mt-3 md:mt-5 leading-6 md:leading-8 text-[#666] transition-all duration-500 group-hover:text-white/90">
                  {feature.description}
                </p>

                <div className="mt-4 md:mt-8 h-[3px] w-14 rounded-full bg-[#D4CB2F] transition-all duration-500 group-hover:w-24 group-hover:bg-white" />
              </div>
            </div>
          ))}
        </div>
      </section> */}

      <section className="relative overflow-hidden py-24 bg-[#1B1A18]">
        {/* Glow */}
        <div className="absolute left-0 top-0 h-full w-1/3 bg-[radial-gradient(circle_at_center,rgba(212,203,47,0.12),transparent_70%)]" />

        <div className="container mx-auto px-5">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            {/* Left */}
            <motion.div
              initial={{ opacity: 0, x: -40 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.7 }}
              viewport={{ once: true }}
            >
              <span className="inline-flex items-center gap-2 px-5 py-2 rounded-full border border-[#D4CB2F40] text-[#D4CB2F] text-sm">
                <Quote size={14} />
                Our Testimonials
              </span>

              <h2 className="mt-8 text-4xl lg:text-6xl font-bold text-white leading-tight">
                What customers say
                <br />
                about our
                <span className="text-[#D4CB2F]"> services</span>
              </h2>

              <p className="mt-6 text-xl text-[#D4CB2F] font-semibold">
                1,000+ Happy Customers
              </p>

              <div className="w-24 h-[2px] bg-[#D4CB2F] mt-10" />
            </motion.div>

            {/* Right */}
            <div className="relative">
              <AnimatePresence mode="wait">
                <motion.div
                  key={active}
                  initial={{ opacity: 0, y: 50 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -50 }}
                  transition={{ duration: 0.5 }}
                  className="relative p-8 md:p-10 rounded-[30px]
                border border-[#D4CB2F25]
                bg-gradient-to-br
                from-[#2A2825]
                to-[#1D1C1A]
                backdrop-blur-xl
                shadow-[0_0_40px_rgba(212,203,47,0.08)]"
                >
                  {/* Quote */}
                  <Quote
                    className="absolute top-8 right-8 text-[#D4CB2F40]"
                    size={40}
                  />

                  {/* User */}
                  <div className="flex items-center gap-5">
                    <div
                      className="w-16 h-16 rounded-full
                    bg-gradient-to-br
                    from-[#D4CB2F]
                    to-[#8D8622]
                    flex items-center justify-center
                    font-bold text-black"
                    >
                      {testimonials[active].initials}
                    </div>

                    <div>
                      <h3 className="text-white text-xl font-semibold">
                        {testimonials[active].name}
                      </h3>

                      <p className="text-gray-400">
                        {testimonials[active].location}
                      </p>
                    </div>
                  </div>

                  {/* Review */}
                  <div className="mt-10 border-l-2 border-[#D4CB2F] pl-6">
                    <p className="text-lg leading-9 text-gray-300">
                      {testimonials[active].review}
                    </p>
                  </div>

                  <div className="border-t border-[#ffffff10] mt-10 pt-6 flex items-center justify-between flex-wrap gap-4">
                    <h4 className="text-[#D4CB2F] font-semibold">
                      {testimonials[active].title}
                    </h4>

                    <div className="flex gap-1">
                      {[...Array(5)].map((_, i) => (
                        <Star
                          key={i}
                          size={16}
                          className="fill-[#D4CB2F] text-[#D4CB2F]"
                        />
                      ))}
                    </div>
                  </div>
                </motion.div>
              </AnimatePresence>

              {/* Bottom Controls */}
              <div className="flex items-center justify-between mt-8">
                <div className="flex gap-2">
                  {testimonials.map((_, i) => (
                    <button
                      key={i}
                      onClick={() => setActive(i)}
                      className={`h-2 rounded-full transition-all duration-300 ${
                        active === i ? "w-10 bg-[#D4CB2F]" : "w-2 bg-white/20"
                      }`}
                    />
                  ))}
                </div>

                <div className="flex gap-3">
                  <button
                    onClick={prevSlide}
                    className="w-12 h-12 rounded-xl border border-white/10 bg-white/5 text-white hover:border-[#D4CB2F]"
                  >
                    <ChevronLeft className="mx-auto" />
                  </button>

                  <button
                    onClick={nextSlide}
                    className="w-12 h-12 rounded-xl border border-white/10 bg-white/5 text-white hover:border-[#D4CB2F]"
                  >
                    <ChevronRight className="mx-auto" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 px-4">
        <div
          className="
      relative
      max-w-7xl
      mx-auto
      overflow-hidden
      rounded-[40px]
      border
      bg-gradient-to-br
      from-[#8e8e40]
      to-[#5c5613]
      shadow-[0_20px_60px_rgba(212,203,47,0.12)]
    "
        >
          {/* Decorative Blur */}
          <div className="absolute -top-20 -left-20 h-56 w-56 rounded-full bg-[#D4CB2F]/10 blur-3xl" />
          <div className="absolute -bottom-20 -right-20 h-64 w-64 rounded-full bg-[#D4CB2F]/10 blur-3xl" />

          <div className="relative z-10 px-6 py-12 sm:px-10 md:px-16 lg:px-20 lg:py-16">
            <div className="grid lg:grid-cols-[1fr_auto] gap-10 lg:gap-16 items-center">
              {/* Content */}
              <div>
                <span
                  className="
              inline-flex
              items-center
              rounded-full
              border
              border-[#D4CB2F]/30
              bg-white/60
              px-3
              py-1.5
              font-semibold
              uppercase
              tracking-[3px]
              text-black
              backdrop-blur-sm
               gap-3 md:px-4 md:py-2.5 text-[12px] md:text-[14px]
            "
                >
                  Healthcare Made Simple
                </span>

                <h2
                  className="mt-3
              md:mt-5
              text-2xl
              sm:text-4xl
              md:text-5xl
              lg:text-6xl
              font-bold
              leading-tight
              text-[#3F3D3A]
            "
                >
                  Your Health,
                  <span className="block text-[#D4CB2F]">Our Priority</span>
                </h2>

                <p
                  className="
              mt-4 md:mt-6
              max-w-2xl
              text-[14px]
              sm:text-base
              md:text-lg
              leading-6 md:leading-8
              text-white
            "
                >
                  Affordable healthcare plans designed for individuals and
                  families with trusted support, wellness benefits, and complete
                  peace of mind. Access quality care whenever you need it
                  through our seamless digital healthcare platform.
                </p>
              </div>

              {/* CTA */}
              <div className="flex lg:justify-end">
                <Link
                  to="/plans"
                  className="group inline-flex items-center gap-3 rounded-full px-6 py-3 text-[14px] md:text-[16px] md:px-8 md:py-4 font-semibold text-white transition-all duration-300 hover:-translate-y-1 bg-[#D4CB2F]"
                >
                  <span>Explore Plans</span>

                  <svg
                    className="transition-transform duration-300 group-hover:translate-x-1"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M4 10H16"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                    />
                    <path
                      d="M10 4L16 10L10 16"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                    />
                  </svg>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
    </>
  );
};

export default HomePage;
